// extracted by mini-css-extract-plugin
module.exports = {"text":"YZ4BbO","shine-lines":"_1pJx4p"};